import axios from 'axios';
import BaseAPI from './base/base-api';

class UserTaxAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'ManagementAPI';
	controllerName = 'usertax';
}

export default new UserTaxAPI();
